import { apiFetchV2 } from '@m/utils/http';

import type {
  RegisterAndApplyValidationRequest,
  RegisterAndApplyValidationResponse,
} from '../types/kioskValidation';

export const KioskValidationService = {
  registerAndApplyValidation: (params: RegisterAndApplyValidationRequest) =>
    apiFetchV2<RegisterAndApplyValidationResponse>(
      '/kiosk/validations/registerAndApplyValidation',
      {
        method: 'POST',
        body: params,
      },
    ),
};
